import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { useState, useEffect } from 'react'
import { AuthProvider, useAuth } from './context/AuthContext'
import { Toaster } from 'react-hot-toast'
import GlobalSearch from './components/search/GlobalSearch'

import Landing           from './pages/Landing'
import Login             from './pages/auth/Login'
import Register          from './pages/auth/Register'
import ForgotPassword    from './pages/auth/ForgotPassword'
import ResetPassword     from './pages/auth/ResetPassword'
import PublicViewer      from './pages/public/PublicViewer'
import DashboardLayout   from './components/layout/DashboardLayout'
import Dashboard         from './pages/dashboard/Dashboard'
import Projects          from './pages/dashboard/Projects'
import ProjectDetail     from './pages/dashboard/ProjectDetail'
import Documents         from './pages/dashboard/Documents'
import TestPlans         from './pages/dashboard/TestPlans'
import Specifications    from './pages/dashboard/Specifications'
import Settings          from './pages/dashboard/Settings'
import Billing           from './pages/dashboard/Billing'
import Changelog         from './pages/dashboard/Changelog'
import TestPlanExecutionPage from './pages/dashboard/TestPlanExecutionPage'

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth()
  if (loading) return null
  return user ? children : <Navigate to="/login" replace />
}
function PublicRoute({ children }) {
  const { user, loading } = useAuth()
  if (loading) return null
  return user ? <Navigate to="/dashboard" replace /> : children
}

function AppInner() {
  const [searchOpen, setSearchOpen] = useState(false)
  useEffect(() => {
    const handler = (e) => {
      if ((e.metaKey || e.ctrlKey) && e.key === 'k') {
        e.preventDefault()
        setSearchOpen(s => !s)
      }
    }
    window.addEventListener('keydown', handler)
    return () => window.removeEventListener('keydown', handler)
  }, [])

  return (
    <>
      <Toaster position="bottom-right" toastOptions={{
        style: { background: '#1a0d40', color: '#fff', border: '1px solid rgba(139,63,255,0.2)' },
      }}/>
      {searchOpen && <GlobalSearch onClose={() => setSearchOpen(false)} />}
      <Routes>
        <Route path="/"                 element={<Landing />} />
        <Route path="/view/:token"      element={<PublicViewer />} />
        <Route path="/login"            element={<PublicRoute><Login /></PublicRoute>} />
        <Route path="/register"         element={<PublicRoute><Register /></PublicRoute>} />
        <Route path="/forgot-password"  element={<PublicRoute><ForgotPassword /></PublicRoute>} />
        <Route path="/reset-password"   element={<PublicRoute><ResetPassword /></PublicRoute>} />
        <Route path="/dashboard" element={<ProtectedRoute><DashboardLayout onOpenSearch={() => setSearchOpen(true)} /></ProtectedRoute>}>
          <Route index                              element={<Dashboard />} />
          <Route path="projects"                    element={<Projects />} />
          <Route path="projects/:id"                element={<ProjectDetail />} />
          <Route path="documents"                   element={<Documents />} />
          <Route path="test-plans"                  element={<TestPlans />} />
          <Route path="test-plans/:id/execute"      element={<TestPlanExecutionPage />} />
          <Route path="specifications"              element={<Specifications />} />
          <Route path="settings"                    element={<Settings />} />
          <Route path="billing"                     element={<Billing />} />
          <Route path="repositories/:repositoryId/changelog" element={<Changelog />} />
        </Route>
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </>
  )
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppInner />
      </AuthProvider>
    </BrowserRouter>
  )
}
